<div class="col-md-12 mb-30" >
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0"> بررسی نظرات </h5>
     <br/>

     <div class="row">
      <div  class="form-group col-md-6" >
        <button *ngIf="!Procssing" type="button" (click)="Read_Comments()"  class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام مشتری</th>
              <th>توضیحات</th>
              <th>ثبت کننده</th>
              <th>تاریخ ثبت</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Comment
            | paginate
                    : {
                        id: 'DataList_Comment',
                        itemsPerPage: 100,
                        currentPage: page,
                        totalItems: (DataList_Comment).length
                      }
            " [ngClass]="{'Special': item.special}">
             <td>{{DataList_Comment.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.title}}</td>
              <td>{{item.username}} </td>
              <td>{{item.persianDate}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;" class="dropdown-item" (click)="openModal_Edit(templateEdit,item)"><i class="fa fa-edit"></i> ویرایش </a>
                        <a style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item,1)"><i class="fa fa-check"></i> تایید نظر </a>
                        <a  style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item,-1)"><i class="fa  fa-times"></i> عدم تایید نظر </a>
                      </div>
                  </div>

                  <div *ngIf="item.DeletingProccess" >
                    <img  src="assets/Loading.gif" style="width: 25px;" />
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_Comment"
     nextLabel="بعدی"
     previousLabel="قبلی"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>



<ng-template #template>
  <div class="modal-header">
    <h4 *ngIf="Operation==1"  class="modal-title pull-left">تایید نظر ثبت شده </h4>
    <h4 *ngIf="Operation==-1" class="modal-title pull-left">عدم تایید نظر ثبت شده  </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Operation.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="card-body" *ngIf="Operation==1" >

    <div class="row">
      <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> درجه اهمیت  </label>
          <select [(ngModel)]="Priority" class="custom-select">
            <option value="0">عادی</option>
            <option value="1">مهم</option>
            <option value="2">حیاتی</option>
          </select>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button *ngIf="Operation==1"  type="button" class="btn btn-warning" (click)="OnOperation()"> تایید نظر <i class="fa fa-check"></i></button>
    <button *ngIf="Operation==-1" type="button" class="btn btn-warning" (click)="OnOperation()"> عدم تایید نظر <i class="fa fa-times"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Operation.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateEdit>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> ویرایش نظر مشتری '{{Data_Seleted_Comment.code}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Edit.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">توضیحات</label>
        <input [(ngModel)]="EditDsc"  name="EditDsc" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="Edit()"> ویرایش <i class="fa fa-edit"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Edit.hide()">بستن</button>
  </div>
</ng-template>
